import React, {ReactNode} from 'react';

type GradientBorderButtonProps = {
  children: ReactNode;
  gradient?: string;
  bgColor?: string;
  className?: string;
  onClick?: () => void;
  innerButtonClassName?: string;
  textColor?: string;
};

const GradientBorderButton: React.FC<GradientBorderButtonProps> = ({
  children,
  gradient = 'from-pink-400 via-red-500 to-yellow-500',
  bgColor = 'bg-gray-800',
  className = '',
  innerButtonClassName = '',
  textColor = 'text-transparent',
  onClick,
}) => {
  return (
    <div
      className={`rounded-full p-0.5 bg-gradient-to-r ${gradient} ${className} font-inter animate-gradient bg-[length:200%_200%]`}
    >
      <div
        className={`flex h-full w-full items-center justify-center ${innerButtonClassName} ${bgColor} rounded-full px-2 md:px-6 py-3 text-white `}
        onClick={onClick}
      >
        <p
          className={`animate-gradient bg-[length:200%_200%] bg-gradient-to-r from-pink-400 via-fuchsia-400 to-blue-600 bg-clip-text ${textColor}`}
        >
          {children}
        </p>
      </div>
    </div>
  );
};

export default GradientBorderButton;
